import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableHeadSortLabel } from "./TableHeadSortLabel";

interface Props {
  aggregationUnit: string;
  activeSort: {
    property: "name" | "address" | "quality" | "aggregationUnit" | "currency";
    direction: "asc" | "desc";
  };
  handleSort: (
    property: "name" | "address" | "quality" | "aggregationUnit" | "currency"
  ) => void;
  t: (key: string) => string;
}

export function NoMatchTableHead({
  aggregationUnit,
  activeSort,
  handleSort,
  t
}: Props) {
  return (
    <TableHead>
      <TableRow>
        <TableHeadSortLabel
          property="name"
          activeSort={activeSort}
          handleSort={handleSort}
          width="20%"
        >
          {t("addressEncoding.table.name")}
        </TableHeadSortLabel>
        {aggregationUnit &&
          aggregationUnit !== "numberOfLocations" &&
          aggregationUnit !== "numberOfRisks" &&
          <TableHeadSortLabel
            property="currency"
            activeSort={activeSort}
            handleSort={handleSort}
            width="15%"
          >
            {t("locations.add.currency")}
          </TableHeadSortLabel>}
        {aggregationUnit &&
          aggregationUnit !== "numberOfLocations" &&
          <TableHeadSortLabel
            property="aggregationUnit"
            activeSort={activeSort}
            handleSort={handleSort}
            width="20%"
          >
            {t("locations.add." + aggregationUnit) || ""}
          </TableHeadSortLabel>}
        <TableHeadSortLabel
          property="address"
          activeSort={activeSort}
          handleSort={handleSort}
          width="70%"
        >
          {t("addressEncoding.table.address")}
        </TableHeadSortLabel>
        <TableCell />
      </TableRow>
    </TableHead>
  );
}
